import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import CitationsCitedRefsReorderEditing from "./citationscitedrefsreorderediting";

export default class CitationsCitedRefsReorder extends Plugin {
  static get pluginName() {
    return "CitationsCitedRefsReorder";
  }

  static get requires() {
    return [CitationsCitedRefsReorderEditing];
  }
}
